import get from 'lodash/get';

// eslint-disable-next-line import/prefer-default-export
export const appDataSelector = state => get(state, 'appData');
